
import { getPrizeTierByName } from 'constants/LottoPrizeValues';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { GroupedPrizes } from 'types/Prize';
import { fetchPrizes, fetchPrizesForValidationResult } from 'utils/api/prizes';
import { getCookie } from 'utils/cookie';

export const useFetchPrizes = (
  setPrizesAreGroupedByPageSection: React.Dispatch<
    React.SetStateAction<boolean>
  >,
  tokenRedemptionOption?: string,
  tierQueryString?: string,
  legacyValue?: string,
  pwid?: string,
  validationResult?: { valid: boolean; prizeWinId: string }
) => {
  const [prizesToSelect, setPrizesToSelect] = useState<GroupedPrizes | null>(
    null
  );
  const router = useRouter();
  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    (async () => {
      if (tokenRedemptionOption && (tierQueryString || legacyValue)) {
        const jwt = getCookie('jwt');

        if (!jwt) {
          router.push(
            `/login?redirect=prizes?tokenRedemptionOption=${tokenRedemptionOption}${
              tierQueryString ? `&tier=${tierQueryString}` : ''
            }${legacyValue ? `&value=${legacyValue}` : ''}`
          );
          return;
        }
        let tierValue = undefined;
        if (tierQueryString) {
          tierValue = getPrizeTierByName(tierQueryString).value;
        } else {
          tierValue =
            tierValue ??
            (['5', '10'].includes(legacyValue ?? '0')
              ? parseInt(legacyValue ?? '0', 10)
              : undefined);
        }

        let prizes = await fetchPrizes(jwt, tokenRedemptionOption, tierValue);
        if (!signal.aborted) {
          setPrizesAreGroupedByPageSection(true);
          prizes['BEST_OF_REST'] = prizes['BEST_OF_REST']
            .concat(prizes['HERO'])
            .concat(prizes['TRENDING_GRID'])
            .concat(prizes['LAST']);
          delete prizes['LAST'];
          setPrizesToSelect(prizes);
        }
      }
      if (pwid && validationResult) {
        const jwt = getCookie('jwt');

        if (!jwt) {
          router.push(
            `/login?redirect=prizes?tokenRedemptionOption=${tokenRedemptionOption}${
              tierQueryString ? `&tier=${tierQueryString}` : ''
            }${legacyValue ? `&value=${legacyValue}` : ''}`
          );
          return;
        }
        let prizes = await fetchPrizesForValidationResult(
          jwt,
          validationResult
        );

        if (validationResult.valid) {
          setPrizesAreGroupedByPageSection(true);
          prizes['BEST_OF_REST'] = prizes['BEST_OF_REST']
            .concat(prizes['HERO'])
            .concat(prizes['TRENDING_GRID'])
            .concat(prizes['LAST']);
          delete prizes['LAST'];
          setPrizesToSelect(prizes);
        }
      }
    })();

    return () => {
      abortController.abort(); // Abort fetch on component unmount
    };
  }, [
    pwid,
    validationResult,
    setPrizesAreGroupedByPageSection,
    tokenRedemptionOption,
    tierQueryString,
    legacyValue,
  ]);

  return { prizesToSelect };
};
